module.exports = __webpack_public_path__ + "static/media/chevron-right.ff1a4d21.svg";